<div class="custom-page-column">
  <!-- Page 1 -->
  <div class="pdf-page app-cp-03-21-10-12 font-small" id="cp211012">
    <p class="font-small text-end">
      <b
        >COMMERCIAL PROPERTY<br />
        CP 03 21 10 12</b
      >
    </p>
    <p class="font-medium" style="text-align: center">
      <b>THIS ENDORSEMENT CHANGES THE POLICY. PLEASE READ IT CAREFULLY.</b>
    </p>
    <p class="font-large" style="text-align: center">
      <b>WINDSTORM OR HAIL PERCENTAGE DEDUCTIBLE</b>
    </p>

    <p class="font-small">
      This endorsement modifies insurance provided under the following:
    </p>
    <p class="font-small ps-10">
      BUILDERS RISK COVERAGE FORM <br />
      BUILDING AND PERSONAL PROPERTY COVERAGE FORM <br />
      CONDOMINIUM ASSOCIATION COVERAGE FORM <br />
      CONDOMINIUM COMMERCIAL UNIT-OWNERS COVERAGE FORM <br />
      STANDARD PROPERTY POLICY <br />
      TOBACCO SALES WAREHOUSES COVERAGE FORM <br />
    </p>

    <p style="text-align: center"><b>SCHEDULE</b></p>
    <table
      style="border: 1px solid black; border-collapse: collapse; width: 100%"
    >
      <thead>
        <tr>
          <th style="text-align: center; border: 1px solid black; padding: 5px">
            Premises Number
          </th>
          <th style="text-align: center; border: 1px solid black; padding: 5px">
            Building Number
          </th>
          <th style="text-align: center; border: 1px solid black; padding: 5px">
            Windstorm Or Hail Deductible Percentage – <br />
            Enter 1%, 2% Or 5%
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td style="border: 1px solid black; padding: 5px">
            &nbsp;<br />&nbsp;
          </td>
          <td style="border: 1px solid black; padding: 5px"></td>
          <td style="border: 1px solid black; padding: 5px">
            <div style="text-align: right">%</div>
          </td>
        </tr>
        <tr>
          <td style="border: 1px solid black; padding: 5px">
            &nbsp;<br />&nbsp;
          </td>
          <td style="border: 1px solid black; padding: 5px"></td>
          <td style="border: 1px solid black; padding: 5px">
            <div style="text-align: right">%</div>
          </td>
        </tr>
        <tr>
          <td style="border: 1px solid black; padding: 5px">
            &nbsp;<br />&nbsp;
          </td>
          <td style="border: 1px solid black; padding: 5px"></td>
          <td style="border: 1px solid black; padding: 5px">
            <div style="text-align: right">%</div>
          </td>
        </tr>
        <tr>
          <td colspan="3" style="border: 1px solid black; padding: 5px">
            Information required to complete this Schedule, if not shown above,
            will be shown in the Declarations
          </td>
        </tr>
      </tbody>
    </table>

    <table style="width: 100%;">
      <tbody>
        <tr>
          <td style="width: 50%; vertical-align: top;">
            The Windstorm or Hail Deductible, as shown in the Schedule and set
            forth in this endorsement, applies to covered loss or damage caused
            directly or indirectly by Windstorm or Hail. This Deductible applies
            to each occurrence of Windstorm or Hail. <br />
            Nothing in this endorsement implies or affords coverage for any loss
            or damage that is excluded under the terms of the Water Exclusion or
            any other exclusion in this policy. If this policy is endorsed to
            cover Flood under the Flood Coverage Endorsement (or if you have a
            flood insurance policy), a separate Flood Deductible applies to loss
            or damage attributable to Flood, in accordance with the terms of
            that endorsement or policy. <br />
            As used in this endorsement, the terms "specific insurance" and
            "blanket insurance" have the following meanings: Specific insurance
            covers each item of insurance (for example, each building or
            personal property in a building) under a separate Limit of
            Insurance. Blanket insurance covers two or more items of insurance
            (for example, a building and personal property in that building, or
            two buildings) under a single Limit of Insurance. Items of insurance
            and corresponding Limit(s) Of Insurance are shown in the
            Declarations.
          </td>
          <td style="width: 50%; vertical-align: top;">
            <b>WINDSTORM OR HAIL DEDUCTIBLE CALCULATIONS</b> <br />
            <ol type="A">
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                <b>Calculation Of The Deductible – All Policies</b>
                <ol>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                    A Deductible is calculated separately for, and applies
                    separately to:
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">Each building that sustains loss or damage;</span>
              </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                        The personal property at each building at which there is
                        loss or damage to personal property; and
                      </span>
              </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">Personal property in the open.</span>
              </li>
                    </ol>
                    If there is damage to both a building and personal property
                    in that building, separate deductibles apply to the building
                    and to the personal property.
                  </span>
              </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                    We will not pay for loss or damage until the amount of loss
                    or damage exceeds the applicable Deductible. We will then
                    pay the amount of loss or damage in excess of that
                    Deductible, up to the applicable Limit of Insurance, after
                    any reduction required by any of the following: Coinsurance
                    Condition; Agreed Value Optional Coverage; or any provision
                    in a Value Reporting Form relating to full reporting or
                    failure to submit reports.
                  </span>
              </li>
                </ol>
              </span>
              </li>
            </ol>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Page 2 -->
  <div class="pdf-page app-cp-03-21-10-12 font-small">
    <table style="width: 100%">
      <tbody>
        <tr>
          <td style="width: 50%;vertical-align: top;">
            <ol type="A" start="2">
              <ol start="3">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  When property is covered under the Coverage Extension for
                  Newly Acquired Or Constructed Property: In determining the
                  amount, if any, that we will pay for loss or damage, we will
                  deduct an amount equal to a percentage of the value(s) of the
                  property at time of loss. The applicable percentage for Newly
                  Acquired Or Constructed Property is the highest percentage
                  shown in the Schedule for any described premises.
                </span>
              </li>
              </ol>
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                <b
                  >Calculation Of The Deductible – Specific Insurance Other than
                  Builders' Risk</b
                ><br />
                <ol>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                    <b>Property Not Subject To Value Reporting Forms</b><br />In
                    determining the amount, if any, that we will pay for loss or
                    damage, we will deduct an amount equal to 1%, 2% or 5% (as
                    shown in the Schedule) of the Limit(s) of Insurance
                    applicable to the property that has sustained loss or
                    damage.
                  </span>
              </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                    <b>Property Subject To Value Reporting Forms</b><br />
                    In determining the amount, if any, that we will pay for loss
                    or damage, we will deduct an amount equal to 1%, 2% or 5%
                    (as shown in the Schedule) of the value(s) of the property
                    that has sustained loss or damage. The value(s) to be used
                    is the latest value(s) shown in the most recent Report of
                    Values on file with us. <br />
                    However: <br />
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                        If the most recent Report of Values shows less than the
                        full value(s) of the property on the report dates, we
                        will determine the deductible amount as a percentage of
                        the full value(s) as of the report dates.
                      </span>
              </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                        If the first Report of Values is not filed with us prior
                        to loss or damage, we will determine the deductible
                        amount as a percentage of the applicable Limit(s) of
                        Insurance.
                      </span>
              </li>
                    </ol>
                  </span>
              </li>
                </ol>
              </span>
              </li>
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                <b
                  >Calculation Of The Deductible – Blanket Insurance Other Than
                  Builders' Risk</b
                ><br />
                <ol>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                    <b>Property Not Subject To Value Reporting Forms </b> <br />
                    In determining the amount, if any, that we will pay for loss
                    or damage, we will deduct an amount equal to 1%, 2% or 5%
                    (as shown in the Schedule) of the value(s) of the property
                    that has sustained loss or damage. The value(s) to be used
                    is that shown in the most recent Statement of Values on file
                    with us.
                  </span>
              </li>
                </ol>
              </span>
              </li>
            </ol>
          </td>
          <td style="width: 50%; vertical-align: top;">
            <ol type="A" start="4">
              <ol start="2">
                <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                  <b>Property Subject To Value Reporting Forms</b><br />
                  In determining the amount, if any, that we will pay for
                  property that has sustained loss or damage, we will deduct an
                  amount equal to 1%, 2% or 5% (as shown in the Schedule) of the
                  value(s) of that property as of the time of loss or damage.
                </span>
              </li>
              </ol>
              <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                <b>Calculation Of The Deductible – Builders' Risk Insurance </b
                ><br />
                <ol>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                    <b>Builders' Risk Other Than Reporting Form</b><br />
                    In determining the amount, if any, that we will pay for
                    property that has sustained loss or damage, we will deduct
                    an amount equal to 1%, 2% or 5% (as shown in the Schedule)
                    of the actual cash value(s) of that property as of the time
                    of loss or damage.
                  </span>
              </li>
                  <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                    <b>Builders' Risk Reporting Form</b><br />
                    In determining the amount, if any, that we will pay for loss
                    or damage, we will deduct an amount equal to 1%, 2% or 5%
                    (as shown in the Schedule) of the value(s) of the property
                    that has sustained loss or damage. The value(s) to be used
                    is the actual cash value(s) shown in the most recent Report
                    of Values on file with us. <br />
                    However: <br />
                    <ol type="a">
                      <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                        If the most recent Report of Values shows less than the
                        actual cash value(s) of the property on the report date,
                        we will determine the deductible amount as a percentage
                        of the actual cash value(s) as of the report date.
                      </span>
              </li>
                      <li style="padding-bottom: 10px; font-weight: bold;">
                <span style="font-weight: normal;">
                        If the first Report of Values is not filed with us prior
                        to loss or damage, we will determine the deductible
                        amount as a percentage of the actual cash value(s) of
                        the property as of the time of loss or damage.
                      </span>
              </li>
                    </ol>
                  </span>
              </li>
                </ol>
              </span>
              </li>
            </ol>

            <b
              >Examples – Application Of Deductible <br />
              Example 1 – Specific Insurance (B.1.)</b
            >
            <br />
            The amount of loss to the damaged building is $60,000. <br />
            The value of the damaged building at time of loss is $100,000. The
            Coinsurance percentage shown in the Declarations is 80%; the minimum
            Limit of Insurance needed to meet the Coinsurance requirement is
            $80,000 (80% of $100,000).
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Page 3 -->
  <div class="pdf-page app-cp-03-21-10-12 font-small">
    <table style="width: 100%">
      <tbody>
        <tr>
          <td style="width: 50%; vertical-align: top;">
            The actual Limit of Insurance on the damaged building is $70,000.
            <br /><br />
            The Deductible is 1%. <br /><br />
            Step <b>(1):</b> $70,000 ÷ $80,000 = .875 <br /><br />
            Step <b>(2):</b> $60,000 x .875 = $52,500 <br /><br />
            Step <b>(3):</b> $70,000 x 1% = $700 <br /><br />
            Step <b>(4):</b> $52,500 – $700 = $51,800 <br /><br />
            The most we will pay is $51,800. The remainder of the loss, $8,200,
            is not covered due to the Coinsurance penalty for inadequate
            insurance (Steps
            <b>(1)</b> and <b>(2)</b>) and the application of the Deductible
            (Steps <b>(3)</b> and <b>(4)</b>). <br /><br />
            <b>Example 2 – Specific Insurance (B.1.)</b><br /><br />
            The amounts of loss to the damaged property are $60,000 (Building)
            and $40,000 (Personal Property in building). <br /><br />
            The value of the damaged building at time of loss is $100,000. The
            value of the personal property in that building is $80,000. The
            Coinsurance percentage shown in the Declarations is 80%; the minimum
            Limits of Insurance needed to meet the Coinsurance requirement are
            $80,000 (80% of $100,000) for the building and $64,000 (80% of
            $80,000) for the personal property. <br /><br />
            The actual Limits of Insurance on the damaged property are $80,000
            on the building and $64,000 on the personal property (therefore, no
            Coinsurance penalty). <br /><br />
            The Deductible is 2%. <br /><br />
            <b>Building</b> <br /><br />
            Step <b>(1)</b>: $80,000 x 2% = $1,600 <br /><br />
            Step <b>(2)</b>: $60,000 – $1,600 = $58,400 <br /><br />
            <b>Personal Property</b> <br /><br />
            Step <b>(1)</b>: $64,000 x 2% = $1,280 <br /><br />
            Step <b>(2)</b>: $40,000 – $1,280 = $38,720 <br /><br />
            The most we will pay is $97,120. The portion of the total loss not
            covered due to application of the Deductible is $2,880. <br /><br />
            <b>Example 3 – Blanket Insurance (C.1.)</b> <br /><br />
            The sum of the values of Building 1 ($500,000), Building 2
            ($500,000) and Building 3 ($1,000,000), as shown in the most recent
            Statement of Values on file with us, is $2,000,000. <br /><br />
            The Coinsurance percentage shown in the Declarations is 90%; the
            minimum Blanket Limit of Insurance needed to meet the Coinsurance
            requirement is $1,800,000 (90% of $2,000,000).
          </td>
          <td style="width: 50%; vertical-align: top;">
            The actual Blanket Limit Of Insurance covering Buildings 1, 2, and
            3, shown in the Declarations, is $1,800,000 (therefore, no
            Coinsurance penalty). <br /><br />
            Buildings 1 and 2 have sustained damage; the amounts of loss to
            these buildings are $40,000 (Building 1) and $20,000 (Building 2).
            <br /><br />
            The Deductible is 2%. <br /><br />
            <b>Building 1</b> <br /><br />
            Step <b>(1)</b>: $500,000 x 2% = $10,000 <br /><br />
            Step <b>(2)</b>: $40,000 – $10,000 = $30,000 <br /><br />
            <b>Building 2</b> <br /><br />
            Step <b>(1)</b>: $500,000 x 2% = $10,000 <br /><br />
            Step <b>(2)</b>: $20,000 – $10,000 = $10,000 <br /><br />
            The most we will pay is $40,000. The portion of the total loss not
            covered due to application of the Deductible is $20,000. <br /><br />
            <b>Example 4 – Blanket Insurance (C.1.)</b> <br /><br />
            The sum of the values of Building 1 ($500,000), Building 2
            ($500,000), Personal Property at Building 1 ($250,000) and Personal
            Property at Building 2 ($250,000), as shown in the most recent
            Statement of Values on file with us, is $1,500,000. <br /><br />
            The Coinsurance percentage shown in the Declarations is 90%; the
            minimum Blanket Limit of Insurance needed to meet the Coinsurance
            requirement is $1,350,000 (90% of $1,500,000). <br /><br />
            The actual Blanket Limit Of Insurance covering Buildings 1 and 2 and
            Personal Property at Buildings 1 and 2, shown in the Declarations,
            is $1,350,000. Therefore, there is no Coinsurance penalty. <br /><br />
            Building 1 and Personal Property at Building 1 have sustained
            damage; the amounts of loss are $95,000 (Building) and $5,000
            (Personal Property). <br /><br />
            The Deductible is 5%. <br /><br />
            <b>Building</b> <br /><br />
            Step <b>(1)</b>: $500,000 x 5% = $25,000 <br /><br />
            Step <b>(2)</b>: $95,000 – $25,000 = $70,000 <br /><br />
            <b>Personal Property</b> <br /><br />
            Step <b>(1)</b>: $250,000 x 5% = $12,500 <br /><br />
            The loss, $5,000, does not exceed the Deductible. <br /><br />
            The most we will pay is $70,000. The remainder of the building loss,
            $25,000, is not covered due to application of the Deductible. There
            is no loss payment for the personal property
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
